export const lkUrlReducer = (state: string = '') => state;
